<template>
    <div class="table-data-root">
    <div class="tableCornerRadiusForAudit bg-white table-card-shell">
        <div class="table-card-inner">
            <div class="table-container table-container-fit">
            <div class="table-header-wrap">
            <table class="table-fit-card table-header-table" :style="tableResizeStyle">
                <colgroup>
                    <col v-for="columnName in columnNames" :key="'h-'+columnName" :style="columnStyle(columnName)" />
                </colgroup>
                <thead>
                    <tr class="table-header-row">
                    <th scope="col" v-for="columnName in columnNames" :key="columnName" :class="getColumnHeadWidth(columnName)" class="bg-white capitalize resizable-th" :style="columnStyle(columnName)" @click="onHeaderClick(columnName)">
                        <div class="flex justify-center items-center" v-if="columnName == 'deleteIcon'">
                            </div> 
                        <div class="flex" v-else>
							<div class="cursor-pointer">{{ getColumnLabel(columnName) }}</div>
                            <div class="sort cursor-pointer" :class="className == columnName ? classSort : 'opacity-50'" v-if="getColumnLabel(columnName) != ''"></div>
                        </div>
                    <span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, columnName)"></span>
                    </th>
                    </tr>
                </thead>
            </table>
            </div>
            <div class="table-body-scroll">
            <table class="table-fit-card" :style="tableResizeStyle">
                <colgroup>
                    <col v-for="columnName in columnNames" :key="'b-'+columnName" :style="columnStyle(columnName)" />
                </colgroup>
                <tbody v-if="sortedData.length == 0">
                    <tr class="cursor-pointer empty rowHeight">
                        <td class="relative h-10" :colspan="columnNames.size">
                            <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                        </td>
                    </tr>
                </tbody>
                <tbody class="nonEmptyTable" v-else>
                    <tr v-for="(row, index) in sortedData" :key="row" class="cursor-pointer rowHeight">
                        <td v-for="columnName in columnNames" :key="columnName" @mouseout="doFalse()" class="cursor-pointer relative" :class="getColumnHeadWidth(columnName)" :style="columnStyle(columnName)">
                            <div class="my-1" v-if="columnName == 'teamOwner'">
                                <!-- <multiselect
                                    v-model="row.teamOwner"
                                    :options="TeamOwnerOptions"
                                    :showNoOptions="false"
                                    @search-change="asyncFind1"
                                    @select="checkAfterRequired('check')"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    open-direction="bottom"
                                    label="label"
                                    track-by="value"  
                                    :searchable="true"
                                    :hideArrow="false"
                                    placeholder="Team Owner"
                                    class="custom-multiselect userSelect"
                                    :class="{
                                        'is-invalidmultiselect': validationErrors[index]?.teamOwner || validationErrors[index]?.sameAuditorAuditee
                                    }"
                                >
                                    <template v-slot:noResult>
                                        <span class="text-xs">No Members Found</span>
                                    </template>
                                </multiselect> -->
                                 <AutoComplete 
                                    v-model="row.teamOwner"
                                    :suggestions="TeamOwnerOptions"
                                    @complete="asyncFind1"
                                    @change="checkAfterRequired('check')"
                                    optionLabel="label"
                                    optionValue="value"
                                    :forceSelection="true"
                                    placeholder="TeamLeader"
                                    class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
                                    :class="{
                                        'p-invalid': validationErrors[index]?.teamOwner || validationErrors[index]?.sameAuditorAuditee,
                                    }"
                                    />
                                <div class="text-red-500">		
                                    <div class="error-text" v-if="validationErrors[index]?.teamOwner">Required</div>
                                    <div class="error-text" v-if="validationErrors[index]?.sameAuditorAuditee">Team Owner and Reviewer cannot be the same</div>
                                </div>
                            </div>
                            <div v-else-if="columnName == 'reviewer'">
                                <AutoComplete 
                                    v-model="row.reviewer"
                                    :suggestions="reviewerOptions"
                                    @complete="asyncFind"
                                    @change="checkAfterRequired('check')"
                                    optionLabel="label"
                                    optionValue="value"
                                    :forceSelection="true"
                                    placeholder="TeamLeader"
                                    class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
                                    :class="{
                                        'p-invalid': validationErrors[index]?.reviewer || validationErrors[index]?.sameAuditorAuditee
                                    }"
                                    />
                                <!-- <multiselect
                                    v-model="row.reviewer"
                                    :options="reviewerOptions"
                                    :showNoOptions="false"
                                    @search-change="asyncFind"
                                    @change="checkAfterRequired('check')"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    open-direction="bottom"
                                    label="label"
                                    track-by="value"  
                                    :searchable="true"
                                    :hideArrow="false"
                                    placeholder="Reviewer"
                                    class="custom-multiselect userSelect mt-2"
                                    :class="{
                                        'is-invalidmultiselect': validationErrors[index]?.reviewer || validationErrors[index]?.sameAuditorAuditee
                                    }"
                                >
                                    <template v-slot:noResult>
                                        <span class="text-xs">No Members Found</span>
                                    </template>
                                </multiselect> -->
                                <div class="text-red-500">		
                                    <div class="error-text" v-if="validationErrors[index]?.reviewer">Required</div>
                                    <div class="error-text" v-if="validationErrors[index]?.sameAuditorAuditee">Team Owner and Reviewer cannot be the same</div>
                                </div>
                            </div>
                            <div v-else-if="columnName=='entity'||columnName=='location'">
                                <div class="table-ellipsis">
                                    <div @mousemove="toolTip(columnName, $event, index, row, 'text')">
                                        {{getLocationName(row[columnName])  }}
                                    </div>
                                </div>
                                <div v-if="pop == true && sortedData[tipIndex][columnName] == tipText && tipColumn == columnName && tipIndex == index">
                                    <tool-tip :columnName="columnName" :tipText="tipText" :styling="styling"></tool-tip>
                                </div>
                            </div>
                            <div v-else-if="columnName == 'deleteIcon'">
                                    <div class="flex pl-4">
                                        <img src="@/assets/deleteIcon.svg" class="h-5 cursor-pointer w-5 mx-2.5" @click="emitDeleteRowEvent(row)"/>
                                    </div>
                                </div>
                            <div v-else-if="columnName=='team'">
                                <div class="table-ellipsis">
                                    <div @mousemove="toolTip(columnName, $event, index, row, 'text')">
                                        {{getTeamName(row[columnName])  }}
                                    </div>
                                </div>
                                <div v-if="pop == true && sortedData[tipIndex][columnName] == tipText && tipColumn == columnName && tipIndex == index">
                                    <tool-tip :columnName="columnName" :tipText="tipText" :styling="styling"></tool-tip>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
            </div>
            <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :entityId="entityId" :sortedData="sortedData"></pagination>
        </div>
    </div>
    </div>
    
</template>
<style scoped>
tr:last-child {
    border-bottom: 1px solid #e9e9e9 ;
}
.w-40 {
    width: 155px;
}
.table-ellipsis {
  display:-webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.borderRed {
  border: 1px solid red !important;
}
.tableContainer{
    overflow-y: hidden;
}
.resizable-th {
	position: relative;
}
.column-resize-handle {
	position: absolute;
	top: 0;
	right: 0;
	width: 6px;
	height: 100%;
	cursor: col-resize;
	user-select: none;
	z-index: 2;
}
.table-data-root {
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
	height: auto;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.table-card-shell {
	display: flex;
	flex-direction: column;
	flex: 0 1 auto;
	width: 100%;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.table-card-inner {
	display: flex;
	flex-direction: column;
	flex: 0 1 auto;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.table-card-inner > :last-child {
	flex-shrink: 0;
}
.table-container-fit {
	width: 100%;
	max-width: 100%;
	display: flex;
	flex-direction: column;
	flex: 0 1 auto;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.table-header-wrap {
	flex-shrink: 0;
	overflow-x: hidden;
	overflow-y: scroll;
	scrollbar-gutter: stable;
	scrollbar-width: thin;
	scrollbar-color: transparent transparent;
}
.table-header-wrap::-webkit-scrollbar {
	width: 6px !important;
	background: transparent !important;
}
.table-body-scroll {
	flex: 0 1 auto;
	min-height: 0;
	overflow-x: hidden;
	overflow-y: auto;
	overscroll-behavior: contain;
	scrollbar-gutter: stable;
	scrollbar-width: thin;
	scrollbar-color: #c4c4c4 transparent;
	background: #ffffff;
}
.table-fit-card {
	table-layout: fixed;
	border-collapse: collapse;
	border-spacing: 0;
}
.table-header-table {
	width: auto;
	border-collapse: separate;
	border-spacing: 0;
}
.table-header-table thead tr:first-child,
.table-header-table thead tr.table-header-row {
	border-top: none !important;
}
.table-header-table thead tr.table-header-row th,
.table-header-table thead tr:first-child th {
	border-top: none !important;
	border-bottom: 1px solid var(--color-lightgrey) !important;
	box-shadow: none !important;
}
.table-body-scroll tbody tr:first-child {
	border-top: none !important;
}
</style>
<style>
body.col-resizing {
	cursor: col-resize !important;
	user-select: none !important;
}
</style>

<script lang="ts">
import { emitter, toast } from '@/main';
import Multiselect from 'vue-multiselect';
import _ from 'lodash';
import { defineComponent } from 'vue';
import toolTip from '@/components/toolTip.vue';
import pagination from '@/components/pagination.vue';
import useVuelidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import AutoComplete from 'primevue/autocomplete';
import { mapGetters } from 'vuex';

export default defineComponent({
    props: ['tableRowData', 'tabelActionBtn', 'tableRouteArr', 'departmentArr', 'headersData', 'locations','userArray'],
    data(): any {
        return {
            v$:useVuelidate(),
            tableHead: [],
            tableRow: [],
            searchTableRow: [],
            entityId: '',
            visibility: false,
            className: '',
            classSort: '',
            currentSort: 'name',
            currentSortDir: 'asc',
            showDropDown: false,
            showBlock: false,
            validationErrors: [],

            currentPage: '',
            pageSize: '',
            dynamicPagination: '',

            pop: false,
            styling: { left: '', bottom: '' },
            tipText: '',
            tipColumn: '',
            tipIndex: '',
            filters: {},
            columnWidths: {},
            resizingColumn: null,
            resizeStartX: 0,
            resizeStartWidth: 0,
            didResize: false,
            users: [],
            optionsUserArray: [],
            TeamOwnerOptions:[],
            reviewerOptions:[],
            selectedRowIndex: '',
            action:'',
            userInfoFilteredDetails : {},
            columns:[
                {key:'entity',value:'Location'},
                {key:'teamOwner',value:'team Representative'},
                {key:'reviewer',value:'Reviewer'}
            ]
        };
    },
    validations(){
		return{
            sortedData: {
                $each: helpers.forEach({
                    teamOwner:{required},
                    reviewer:{required}
                })
            }
        }
    },
    components: {
        toolTip,
        Multiselect,
        AutoComplete,
        pagination
    },
    async mounted() {
        this.initialize();
        await this.getAllUsers();
        await this.checkAfterRequired('check')
        emitter.on('visible', (isBoolean: any) => {
            this.visibility = isBoolean;
            this.visibility == false ? (this.filters = {}) : '';
        });
        emitter.off('checkAuditValidation')
        emitter.on('checkAuditValidation', (action:any) => {
            this.action = action;
            this.v$.$touch();
            if(!this.v$.sortedData.$invalid){
                this.checkAfterRequired('save')
            }else{
                toast.error(`Validation Error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        });
        // let userInfoFilteredDetails = this.userInfo;
            // this.userInfoFilteredDetails = {
            //   label: this.userInfo.name,
            //   value: this.userInfo._id,
            // };
            // console.log('userInfoFilteredDetails',this.userInfoFilteredDetails)
            // this.optionUserArray.push(obj);
        window.addEventListener('resize', this.clampWidthsToContainer);
    },
    beforeUnmount() {
        this.stopColumnResize();
        window.removeEventListener('resize', this.clampWidthsToContainer);
    },
    computed: {
            ...mapGetters({ userInfo: "userInfo" }),
        sortedData: function (): any {
            return [...this.tableRow]
                .filter((row: any) => {
                    for (const key in this.filters) {
                        const inputValue = this.filters[key];
                        if (inputValue !== '' && row[key]) {
                            if (Number.isInteger(row[key])) {
                                if (row[key] !== Number(inputValue)) {
                                    return false;
                                }
                            } else {
                                if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                })
                .sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
                .filter((row, index) => {
                    this.dynamicPagination = index + 1;
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
        },
        columnNames: function (): any {
            const names = new Set();
            for (const key of this.headersData) {
                if (key != 'entityId' && key != '_id') names.add(key);
            }
            return names;
        },
		tableResizeStyle(): any {
			const names = Array.from(this.columnNames || []) as string[];
			const widths = this.columnWidths || {};
			const measured = names.filter((name: string) => Number(widths[name]) > 0);
			if (!names.length || measured.length !== names.length) {
				return {
					tableLayout: 'fixed',
					width: '100%',
					maxWidth: '100%',
				};
			}
			const containerWidth = this.getContainerWidth();
			const total = names.reduce((sum: number, name: string) => sum + Number(widths[name]), 0);
			const width = Math.min(total, containerWidth);
			return {
				tableLayout: 'fixed',
				width: width + 'px',
				minWidth: width + 'px',
				maxWidth: '100%',
			};
		},
    },
    watch: {
        visibility(newValue) {
            if (newValue == false) {
                this.initialize();
            }
        },
        tableRowData: {
            handler(newVal, oldVal) {
                this.tableRow = this.tableRowData;
                this.initialize();
            },
            deep: true
        }
    },
    methods: {
        columnStyle(column: any) {
			const width = this.columnWidths[column];
			if (!width) {
				return {};
			}
			return {
				width: width + 'px',
				minWidth: width + 'px',
				maxWidth: width + 'px',
			};
		},
		snapshotColumnWidths() {
			const headers = this.$el?.querySelectorAll?.('.table-header-table thead th') || [];
			const names = Array.from(this.columnNames || []) as string[];
			const next: Record<string, number> = { ...this.columnWidths };
			headers.forEach((th: HTMLElement, index: number) => {
				const column = names[index];
				if (column && next[column] == null) {
					next[column] = Math.max(60, Math.round(th.getBoundingClientRect().width));
				}
			});
			this.columnWidths = next;
		},
		getContainerWidth() {
			const container =
				(this.$el?.querySelector?.('.table-container-fit') as HTMLElement | null) ||
				(this.$el?.querySelector?.('.table-container') as HTMLElement | null) ||
				(this.$el?.querySelector?.('.table-header-wrap') as HTMLElement | null);
			if (container) {
				return Math.max(60, Math.floor(container.clientWidth || container.getBoundingClientRect().width));
			}
			return Math.max(60, Math.floor(this.$el?.clientWidth || 800));
		},
		maxWidthForColumn(column: string, proposedWidth: number) {
			const names = Array.from(this.columnNames || []) as string[];
			const otherWidth = names.reduce((sum: number, name: string) => {
				if (name === column) {
					return sum;
				}
				return sum + (Number(this.columnWidths[name]) || 60);
			}, 0);
			const containerWidth = this.getContainerWidth();
			const maxTotal = Math.max(60, containerWidth - otherWidth);
			return Math.min(proposedWidth, maxTotal, containerWidth);
		},
		clampWidthsToContainer() {
			const names = Array.from(this.columnNames || []) as string[];
			if (!names.length || !Object.keys(this.columnWidths || {}).length) {
				return;
			}
			const containerWidth = this.getContainerWidth();
			const total = names.reduce((sum: number, name: string) => sum + (Number(this.columnWidths[name]) || 0), 0);
			if (total <= containerWidth) {
				return;
			}
			const scale = containerWidth / total;
			const next: Record<string, number> = { ...this.columnWidths };
			names.forEach((name: string) => {
				if (next[name]) {
					next[name] = Math.max(60, Math.round(next[name] * scale));
				}
			});
			let overflow = names.reduce((sum: number, name: string) => sum + (Number(next[name]) || 0), 0) - containerWidth;
			for (let i = names.length - 1; i >= 0 && overflow > 0; i--) {
				const name = names[i];
				const current = Number(next[name]) || 0;
				if (current > 60) {
					const reduced = Math.max(60, current - overflow);
					overflow -= current - reduced;
					next[name] = reduced;
				}
			}
			this.columnWidths = next;
		},
		applyResizeKeepingRightVisible(column: string, proposedWidth: number) {
			const names = Array.from(this.columnNames || []) as string[];
			const idx = names.indexOf(column);
			if (idx < 0) {
				return { [column]: this.maxWidthForColumn(column, proposedWidth) };
			}
			const containerWidth = this.getContainerWidth();
			const leftWidth = names.slice(0, idx).reduce((sum: number, name: string) => {
				return sum + (Number(this.columnWidths[name]) || 60);
			}, 0);
			const rightNames = names.slice(idx + 1);
			const minRight = rightNames.length * 60;
			const maxForResized = Math.max(60, containerWidth - leftWidth - minRight);
			const nextWidth = Math.min(Math.max(60, proposedWidth), maxForResized, containerWidth);
			const next: Record<string, number> = { ...this.columnWidths, [column]: nextWidth };
			const usedLeftAndResized = leftWidth + nextWidth;
			let remaining = Math.max(0, containerWidth - usedLeftAndResized);
			const currentRightTotal = rightNames.reduce((sum: number, name: string) => {
				return sum + (Number(this.columnWidths[name]) || 60);
			}, 0);
			if (rightNames.length && currentRightTotal > remaining) {
				const scale = remaining / currentRightTotal;
				rightNames.forEach((name: string) => {
					next[name] = Math.max(60, Math.round((Number(this.columnWidths[name]) || 60) * scale));
				});
				let overflow =
					rightNames.reduce((sum: number, name: string) => sum + (Number(next[name]) || 0), 0) - remaining;
				for (let i = rightNames.length - 1; i >= 0 && overflow > 0; i--) {
					const name = rightNames[i];
					const current = Number(next[name]) || 0;
					if (current > 60) {
						const reduced = Math.max(60, current - overflow);
						overflow -= current - reduced;
						next[name] = reduced;
					}
				}
			}
			return next;
		},
		startColumnResize(event: MouseEvent, column: any) {
			this.snapshotColumnWidths();
			this.clampWidthsToContainer();
			const th = (event.currentTarget as HTMLElement)?.closest('th');
			this.resizingColumn = column;
			this.resizeStartX = event.clientX;
			this.resizeStartWidth = this.columnWidths[column] || th?.getBoundingClientRect().width || 60;
			this.didResize = false;
			document.body.classList.add('col-resizing');
			document.addEventListener('mousemove', this.onColumnResize);
			document.addEventListener('mouseup', this.stopColumnResize);
		},
		onColumnResize(event: MouseEvent) {
			if (!this.resizingColumn) {
				return;
			}
			const delta = event.clientX - this.resizeStartX;
			if (Math.abs(delta) > 2) {
				this.didResize = true;
			}
			const rawWidth = Math.max(60, Math.round(this.resizeStartWidth + delta));
			if (delta > 0) {
				this.columnWidths = this.applyResizeKeepingRightVisible(this.resizingColumn, rawWidth);
			} else {
				this.columnWidths = {
					...this.columnWidths,
					[this.resizingColumn]: this.maxWidthForColumn(this.resizingColumn, rawWidth),
				};
			}
		},
		stopColumnResize() {
			this.resizingColumn = null;
			document.body.classList.remove('col-resizing');
			document.removeEventListener('mousemove', this.onColumnResize);
			document.removeEventListener('mouseup', this.stopColumnResize);
			this.clampWidthsToContainer();
		},
		onHeaderClick(column: any) {
			if (this.didResize) {
				this.didResize = false;
				return;
			}
			this.sort(column);
		},
        asyncFind1(query:any){
            query=query.query.trim();
            if(query == ''){
                this.TeamOwnerOptions = []
            }else if(query.length >= 1){
                this.TeamOwnerOptions = this.optionsUserArray.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
            }
        },
        asyncFind(query:any){
            query=query.query.trim();
            if(query == ''){
                this.reviewerOptions = []
            }else if(query.length >= 1){
                this.reviewerOptions = this.userArray.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
            }
        },
        async checkAfterRequired(action:any){
            this.validationErrors = this.sortedData.map((row: any) => {
                return {
                        teamOwner: !row.teamOwner,
                        reviewer: !row.reviewer,
                    sameAuditorAuditee: row.reviewer?.value === row.teamOwner?.value
                    };
                });
                if(action == 'save'){
                    const hasErrors = this.validationErrors.some((errors:any) => 
                        errors.teamOwner || errors.reviewer || errors.sameAuditorAuditee
                    );
                    if (hasErrors) {
                        // Prevent saving and show validation messages
                        // console.log('Prevent saving and show validation messages')
                    }else{
                        emitter.emit('auditValidationDone',this.action)
                    }
                }
        },
        getColumnLabel(columnName: any) {
			if (columnName == 'actionButton' || columnName == 'kpiDelete' || columnName == 'deleteIcon' || columnName == 'actionButtonAtCompliance' || columnName == 'actionButtonAtObjective' || columnName=='actionButtonForKPIs'){
                return '';
            }
            const column = this.columns.find((col: { key: any }) => col.key === columnName);
            return column ? column.value : columnName;
        },
        emitDeleteRowEvent(row:any) {
            // Emit the deleteRowFromTable event with the necessary data
            emitter.emit('deleteRowFromTable', {
                team: row.team,
                entity: row.entity
            });
        },
        initialize() {
            this.tableRow = this.tableRowData;
            this.searchTableRow = this.tableRowData;

            this.tableRowData[0] == undefined ? '' : (this.entityId = this.tableRowData[0].entityId);
        },
        paginationUpdations(currentPage: any, pageSize: any) {
            this.currentPage = currentPage;
            this.pageSize = pageSize;
        },
        sort(tableHead: any) {
            this.className = tableHead;
            if (tableHead === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = tableHead;
            this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
        },
        toolTip(column: any, e: any, index: any, row: any, status: any) {
            this.tipText = row[column];
            this.tipColumn = column;
            this.tipIndex = index;

            switch (status) {
                case 'text':
                    this.handleTextTooltip(e);
                    break;
                case 'circleButton':
                    if (e.offsetX < e.target.offsetWidth && e.offsetY < e.target.offsetHeight) {
                        this.pop = true;
                        this.styling.left = e.offsetX + e.target.offsetLeft + 13 + 'px';
                        this.styling.bottom = -18 + 'px';
                    }
            }
        },
        handleTextTooltip(e: any) {
            const container = e.currentTarget.closest('.table-ellipsis');
            if (container && this.isTextOverflowed(container)) {
                this.pop = true;
                this.styling.left = e.offsetX + 38 + 'px';
                this.styling.bottom = -75 + 'px';
            } else {
                this.pop = false;
            }
        },
        isTextOverflowed(element: any) {
            return element.scrollHeight > element.clientHeight;
        },
        getTeamName(deptId: any) {
			let nameOfTeam = this.departmentArr.find((obj: any) => {
				return obj._id == deptId;
			});
			if (nameOfTeam == undefined) {
				let empty = '';
				return empty;
			} else {
				return nameOfTeam.displayName;
			}
		},
        getLocationName(locationId: any) {
			let user = this.locations.find((obj: any) => {
				return obj.value == locationId;
			});
			if (user == undefined) {
				let empty = '';
				return empty;
			} else {
				return user.label;
			}
		},
        getColumnHeadWidth(columnName:any){
			if(columnName == "deleteIcon"){
				return 'w-24';
			}
            if(columnName == "team" || columnName=='entity'){
                return 'w-32';
            }if(columnName == "teamOwner" || columnName=='reviewer'){
                return 'w-44';
            }


		},
        doFalse() {
            this.pop = false;
        },
        async getAllUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
            }
        },
    }
});
</script>
